import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Scrolls to top on every route change. Respects in-page anchors (#section)
// so clicking a TOC link still jumps to the right place.
// Also fires a GA4 page_view event for SPA route changes (HashRouter doesn't
// trigger one automatically; we set send_page_view:false in index.html).
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView();
      } else {
        window.scrollTo(0, 0);
      }
    } else {
      window.scrollTo(0, 0);
    }

    // GA4 page_view on every route change
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', {
        page_path: pathname + (hash || ''),
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
